/**
 * Copyright (c) 2023, CYBRA Corp. All rights reserved.
 */
import { Component, OnInit, Input } from '@angular/core';

import { WorkflowLoopNode } from "../../../models/workflow-loop-node";

@Component({
  selector: 'app-workflow-loop-node',
  templateUrl: './workflow-loop-node.component.html'
})
export class WorkflowLoopNodeComponent implements OnInit {
    @Input()
    node: WorkflowLoopNode;
        
    constructor() { }
    
    ngOnInit() {
    }

}
